import { GeneticEvaluationDto } from 'src/dto/genetic-evaluation.dto'
import { GeneticEvaluationService } from 'src/services/api/genetic-evaluation.service'

export class GeneticEvaluationController {
  private service: GeneticEvaluationService

  constructor() {
    this.service = new GeneticEvaluationService()
  }

  public async getGeneticEvaluationListByFarmId(farmId: string): Promise<GeneticEvaluationDto[]> {
    const response = await this.service.getGeneticEvaluationListByFarmId(farmId)
    return response.data
  }

  public async uploadCsvFile(farmId: string, file: FormData): Promise<any> {
    const response = await this.service.uploadCsvFile(farmId, file)
    return response.data
  }
}
